import React from 'react'
import { Resizable } from "re-resizable";
const style = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "solid 1px #ddd",
    background: "#f0f0f0"
  };
  
export default function EditorSample(){
  return (
    <Resizable
    style={style}
    defaultSize={{
      width: 200,
      height: 'auto'
    }}
  >
    <textarea style={{width:'100%', height:'100%', resize:'none'}}></textarea>
  </Resizable>
  )
}
